import { HttpErrorResponse } from "@angular/common/http";

export interface IUserAddMessagesHelper {
  title: string;
  description: string;
}

type StatusErrors = Record<string, IUserAddMessagesHelper> & { default: IUserAddMessagesHelper };

export class UserAddMessagesHelper {
  private readonly DEFAULT_ERROR: IUserAddMessagesHelper = {
    title: "Não foi possível criar o usuário.",
    description:
      "Estamos trabalhando para resolver esse problema. Por favor, tente novamente mais tarde e, se o erro persistir, entre em contato com a nossa equipe de atendimento.",
  };

  public descriptions: Record<number, StatusErrors> = {
    503: {
      default: {
        ...this.DEFAULT_ERROR,
      },
      "31": {
        title: "Não foi possível criar o usuário.",
        description:
          "Estamos trabalhando para resolver esse problema. Por favor, tente novamente mais tarde e, se o erro persistir, entre em contato com a nossa equipe de atendimento.",
      },
    },
    403: {
      default: {
        ...this.DEFAULT_ERROR,
      },
      "32": {
        title: "Esse e-mail não pode ser utilizado.",
        description:
          "Esse e-mail é de domínio público e não pode ser utilizado nesse cadastro. Por favor, utilize seu e-mail corporativo.",
      },
    },
    422: {
      default: {
        ...this.DEFAULT_ERROR,
      },
      "13": {
        title: "Não foi possível criar o usuário.",
        description:
          "O documento do gestor está sem as informações da empresa. Por favor, verifique os dados e tente novamente.",
      },
      "28": {
        title: "Não foi possível clonar o usuário.",
        description:
          "O usuário não pode ser clonado pois ainda está dentro do período de restrição de 24 horas após o cadastro. Tente novamente mais tarde.",
      },
      "29": {
        title: "Não foi possível clonar o usuário.",
        description:
          "O usuário não pode ser clonado pois possui transações do tipo T. Entre em contato com a nossa equipe de atendimento.",
      },
      "30": {
        title: "Não foi possível clonar o usuário.",
        description:
          "O usuário não pode ser clonado pois está com o status de bloqueado. Entre em contato com a nossa equipe de atendimento.",
      },
      "37": {
        title: "Limite de acessos atingido",
        description:
          "Revise os acessos existentes e exclua os que não forem necessários para criar novos usuários.",
      },
      "38": {
        title: "Não foi possível clonar o usuário.",
        description:
          "O usuário não pode ser clonado pois o logon não está ativo. Entre em contato com a nossa equipe de atendimento.",
      },
    },
  };

  public status = 0;
  public errorObj: { code: string; description: string };

  constructor(error: HttpErrorResponse) {
    this.status = error.status;
    this.errorObj = error?.error[0];
  }

  get error(): IUserAddMessagesHelper {
    const statusErrors = this.descriptions[this.status];
    if (!statusErrors) return this.DEFAULT_ERROR;
    const code = this.errorObj?.code;
    return (code && statusErrors[code]) ? statusErrors[code] : statusErrors.default;
  }
}
